import {
defineCustomElement,
MediaPosterElement
} from "vidstack/elements";

defineCustomElement(MediaPosterElement);